import { array, mixed, number, object, string } from 'yup';
import { EarmarkValueDTO } from '../../../../api/useWhatIfGroupsQuery';

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  Sales: {
    AssetId: string | null;
    SaleYear: string | null;
    SaleValue: number | null;
    Earmarks: EarmarkValueDTO[];
    DoNotSell: boolean;
  }[];
}

export const FORM_SCHEMA = object({
  Sales: array(
    object({
      AssetId: string()
        .typeError('Select the real estate asset.')
        .required('Select the real estate asset.'),
      SaleYear: mixed().when('DoNotSell', {
        is: false,
        then: number()
          .typeError('Select the year this asset will be sold.')
          .nullable(),
      }),
      SaleValue: mixed().when('DoNotSell', {
        is: false,
        then: number().typeError('Enter the net proceeds from this sale.'),
      }),
    }).test('unique-asset', 'You cannot sell the same asset twice.', (asset, ctx) => {
      if (ctx.parent.filter(({ AssetId }) => AssetId === asset.AssetId).length > 1) {
        throw ctx.createError({ path: `${ctx.path}.AssetId` });
      }

      return true;
    }),
  ),
});

export const DEFAULT_SALE = {
  AssetId: null,
  SaleYear: '',
  SaleValue: null,
  Earmarks: [],
  DoNotSell: false,
};

export const DEFAULT_VALUES: FormValues = {
  Sales: [DEFAULT_SALE],
  WhatIfKey: '1001',
  WhatIfType: 1001,
  WhatIfTypeName: 'RealEstateSale',
};
